<template lang="pug">

  .login-component
    form(@submit.prevent="login", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
      form-group-row(name="username" :form="form" :validation="$v.form" :label="$t('login.email')")
        form-input(name="username" type="email" :form="form" :validation="$v.form" :placeholder="$t('login.email_placeholder')")
        .help-block.invalid-feedback(v-if="$v.form.username.$dirty && $v.form.username.$invalid") Email is required
      form-group-row.password(name="password" :form="form" :validation="$v.form" :label="$t('login.password')")
        form-input(name="password" type="password" :form="form" :validation="$v.form" :placeholder="$t('login.password_placeholder')")
        .help-block.invalid-feedback(v-if="$v.form.password.$dirty && $v.form.password.$invalid") Password is required
      .form-group.no-check
        a.form-link(href="#", @click.prevent="showForgotPasswordModal = true") {{ $t('login.forgot_password') }}
      .form-group.no-check
        v-button.btn-default(:disabled="$v.form.$invalid || form.busy" :loading="form.busy" block) {{ $t('login.submit') }}

    modal(v-if="showForgotPasswordModal", @close="showForgotPasswordModal = false")
      form(@submit.prevent='reset', @keydown='formResetPassword.onKeydown($event)', :class="{ 'has-errors': formResetPassword.errors.any() }")
        .v-modal-title {{ $t('forgot_password.title') }}
          .subtitle {{ $t('forgot_password.subtitle') }}
        .v-modal-message
          form-group-row(:form="formResetPassword", name="email")
            form-input(:form="formResetPassword", name="email", type="email", :placeholder="$t('forgot_password.email_placeholder')")
        .v-modal-buttons
          v-button.btn-primary(:loading="formResetPassword.busy") {{ $t('forgot_password.submit') }}

    form(@submit.prevent='resend', @keydown='formResendPassword.onKeydown($event)')
      form-success-modal(:form="formResetPassword")
        template(slot="title") Success!
        template(slot="message") The instructions on how to reset your password were sent to {{ formResetPassword.email }}. Please check your mailbox.
        template(slot="buttons")
          v-button.btn-primary(:loading="formResendPassword.busy") Resend email

    form-success-modal(:form="formResendPassword")
      template(slot="title") Success!
      template(slot="message") We have emailed your password reset link to {{ formResendPassword.email }}!
      template(slot="buttons")
        router-link.btn.btn-primary(:to="{ name: 'sign-in' }") Sign in

</template>

<script>
import Form from 'vform'
import { required, email } from 'vuelidate/lib/validators'
import {mapGetters} from 'vuex'

export default {
  name: 'login',

  props: {
    afterLoginRoute: {
      type: String,
      default: 'user.profile'
    }
  },

  data: () => ({
    form: new Form({
      username: '',
      password: ''
    }),
    showForgotPasswordModal: false,
    formResetPassword: new Form({
      email: ''
    }),
    formResendPassword: new Form({
      email: ''
    })
  }),

  validations: {
    form: {
      username: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },

  computed: {
    ...mapGetters({
      storedAfterLoginRoute: 'afterLoginRoute',
    }),
  },

  created() {
    this.formResetPassword.reseturl =
    this.formResendPassword.reseturl = window.location.origin + this.$router.match({ name: 'user.password.reset' }).path;
  },

  methods: {
    async login () {
      try {
        const { data } = await this.form.post(`${window.addiesaas.url}/api/clients/api/customer/login`);

        this.$store.dispatch('saveToken', {
          token: data.access_token
        })

        await this.$store.dispatch('fetchUser')

        this.$router.push({ name: this.storedAfterLoginRoute || this.afterLoginRoute })
      } catch (error) {
        this.form.errors.set('username', error.response.data.message);
      }
    },

    async reset () {
      await this.formResetPassword.post(`${window.addiesaas.url}/api/user/password/forgot`);
      this.showForgotPasswordModal = false;
    },

    async resend () {
      this.formResendPassword.email = this.formResetPassword.email;
      await this.formResendPassword.post(`${window.addiesaas.url}/api/user/password/forgot`);
      this.formResetPassword.successful = false;
    }
  }
}
</script>
